export default function useBackButton(_) {
// No-op
// BackHandler is not available on web
}
